module.exports = __webpack_public_path__ + "img/amex.9c45718e.png";